import {useMutation, useQueryClient} from '@tanstack/react-query';
import {Integration, IntegrationCreateInput} from 'src/core/data/api/Integration';
import IntegrationService from 'src/services/integration-service';
import {integrationKeys} from './queries';

export const useCreateIntegration = () => {
  const queryClient = useQueryClient();
  const integrationService = new IntegrationService();

  return useMutation({
    mutationFn: (data: IntegrationCreateInput) => integrationService.save(data),
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey: integrationKeys.all});
    },
  });
};

export const useUpdateIntegration = () => {
  const queryClient = useQueryClient();
  const integrationService = new IntegrationService();

  return useMutation({
    mutationFn: (data: Integration) => integrationService.update(data),
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey: integrationKeys.all});
    },
  });
};

export const useDeleteIntegration = () => {
  const queryClient = useQueryClient();
  const integrationService = new IntegrationService();

  return useMutation({
    mutationFn: (id: number) => integrationService.remove(id),
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey: integrationKeys.all});
    },
  });
};
